import React from 'react';
import '../styles/globals.css';
import '../styles/custom.css';
import { Inter, Poppins } from 'next/font/google';
import GoogleAnalytics from '../components/GoogleAnalytics';
import Head from 'next/head';

const inter = Inter({
  variable: '--font-inter',
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '800'],
});

const poppins = Poppins({
  variable: '--font-poppins',
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '800'],
});

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      </Head>
      <main className={`${inter.variable} ${poppins.variable} font-sans antialiased`}>
        <GoogleAnalytics />
        <Component {...pageProps} />
      </main>
    </>
  );
}

export default MyApp;
